module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_pp1_9016.4968d262.png";